import hoverintent from 'hoverintent'

export function loadVueDirectives(app) {
  app.directive('tooltip', {
    beforeMount(el, binding) {
      if (!binding.value) {
        return
      }

      if ($(el).attr('data-original-title') !== binding.value) {
        $(el).tooltip('destroy')
      }

      $(el)
        .attr('data-toggle', 'tooltip')
        .attr('data-html', 'true')
        .attr('data-placement', binding.arg)
        .attr('title', binding.value)
        .attr('data-container', 'body')
        .tooltip({
          title: binding.value,
          trigger: 'manual',
        })

      el.hoverIntent = hoverintent(
        el,
        () => {
          $(el).tooltip('show')
        },
        () => {
          $(el).tooltip('hide')
        },
      )
      $(el).on('click', () => {
        $(this).tooltip('hide')
      })
    },
    unmounted(el) {
      $(el).tooltip('destroy')
      $(el).hoverIntent?.remove()
    },
  })

  // Found here https://stackoverflow.com/questions/36170425/detect-click-outside-element
  app.directive('click-outside', {
    beforeMount(el, binding) {
      el.event = (event) => {
        // here I check that click was outside the el and its children's
        if (!(el === event.target || el.contains(event.target))) {
          // and if it did, call method provided in attribute value
          binding.value(event)
        }
      }
      document.body.addEventListener('click', el.event, true)
    },
    unmounted(el) {
      document.body.removeEventListener('click', el.event)
    },
  })

  app.directive('hover-intent', {
    beforeMount(el, binding) {
      el.hoverIntent = hoverintent(el, binding.value.in, binding.value.out)
      el.hoverIntent.options({ ...el.opts })
    },
    unmounted(el) {
      el.hoverIntent?.remove()
    },
  })
}
